import { render, staticRenderFns } from "./batch-price-update.vue?vue&type=template&id=210c53a0&"
import script from "./batch-price-update.vue?vue&type=script&lang=js&"
export * from "./batch-price-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports